import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const ReportsWrapper = () => import('./components/ReportsWrapper.vue');
const Index = () => import('./Index.vue');
const AgentReportsIndex = () => import('./AgentReportsIndex.vue');
const InboxReportsIndex = () => import('./InboxReportsIndex.vue');
const TeamReportsIndex = () => import('./TeamReportsIndex.vue');
const LabelReportsIndex = () => import('./LabelReportsIndex.vue');
const AgentReportsShow = () => import('./AgentReportsShow.vue');
const InboxReportsShow = () => import('./InboxReportsShow.vue');
const TeamReportsShow = () => import('./TeamReportsShow.vue');
const LabelReportsShow = () => import('./LabelReportsShow.vue');
const CsatResponses = () => import('./CsatResponses.vue');
const BotReports = () => import('./BotReports.vue');
const LiveReports = () => import('./LiveReports.vue');
const SLAReports = () => import('./SLAReports.vue');
const KanbanReportsPage = () => import('kanban/pages/KanbanReportsPage.vue');
const WahaCampaignReportsPage = () =>
  import('waha/campaigns/WahaCampaignReportsPage.vue');
const CostReportsPage = () => import('costs/CostReportsPage.vue');
const CostInvoicesTable = () => import('costs/CostInvoicesTable.vue');
const CostMonthHistoryPage = () => import('costs/CostMonthHistoryPage.vue');

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage'],
  requiresReports: true,
};

const oldReportRoutes = [
  {
    path: 'agent',
    redirect: { name: 'agent_reports_index' },
  },
  {
    path: 'inboxes',
    redirect: { name: 'inbox_reports_index' },
  },
  {
    path: 'label',
    redirect: { name: 'label_reports_index' },
  },
  {
    path: 'teams',
    redirect: { name: 'team_reports_index' },
  },
];

const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta,
    component: AgentReportsIndex,
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta,
    component: AgentReportsShow,
  },

  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta,
    component: InboxReportsIndex,
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta,
    component: InboxReportsShow,
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta,
    component: TeamReportsIndex,
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta,
    component: TeamReportsShow,
  },
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta,
    component: LabelReportsIndex,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta,
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'account_overview_reports', params: to.params };
          },
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta,
          component: LiveReports,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta,
          component: Index,
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'sla',
          name: 'sla_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
            featureFlag: FEATURE_FLAGS.SLA,
            requiresReports: true,
          },
          component: SLAReports,
        },
        {
          path: 'csat',
          name: 'csat_reports',
          meta,
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            requiresReports: true,
          },
          component: BotReports,
        },
        {
          // Kanban funnel analytics (Pro overlay). Gated by the KANBAN feature flag so
          // it only shows for accounts with funnels enabled.
          path: 'funnels',
          name: 'kanban_reports',
          meta: {
            featureFlag: FEATURE_FLAGS.KANBAN,
            permissions: ['administrator', 'report_manage'],
            requiresReports: true,
          },
          component: KanbanReportsPage,
        },
        {
          path: 'campaigns',
          name: 'waha_campaign_reports',
          meta: {
            featureFlag: FEATURE_FLAGS.WAHA_CAMPAIGNS,
            permissions: ['administrator', 'report_manage'],
            requiresWahaCampaigns: true,
            requiresReports: true,
          },
          component: WahaCampaignReportsPage,
        },
        {
          path: 'costs',
          component: CostReportsPage,
          meta: {
            permissions: ['administrator', 'report_manage'],
            requiresCostReports: true,
          },
          children: [
            {
              path: '',
              name: 'cost_reports',
              meta: {
                permissions: ['administrator', 'report_manage'],
                requiresCostReports: true,
              },
              component: CostInvoicesTable,
            },
            {
              path: ':yearMonth',
              name: 'cost_reports_month',
              meta: {
                permissions: ['administrator', 'report_manage'],
                requiresCostReports: true,
              },
              component: CostMonthHistoryPage,
              props: true,
            },
          ],
        },
      ],
    },
  ],
};
